/**
 * Returns a human-readable relative date string for an ISO datetime.
 * Examples: "today", "yesterday", "3 days ago", "2 months ago".
 */
export function relativeDate(isoDatetime: string): string {
  const then = new Date(isoDatetime);
  const now = new Date();

  const thenDay = new Date(then.getFullYear(), then.getMonth(), then.getDate());
  const todayDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  const diffMs = todayDay.getTime() - thenDay.getTime();
  const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return "today";
  if (diffDays === 1) return "yesterday";
  if (diffDays < 30) return `${diffDays} days ago`;
  const diffMonths = Math.round(diffDays / 30.44);
  if (diffMonths === 1) return "1 month ago";
  return `${diffMonths} months ago`;
}
